// app/javascript/controllers/toast_container_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Observe child list changes in the container
    const observer = new MutationObserver(() => this.animateReorder());
    observer.observe(this.element, { childList: true });
  }

  animateReorder() {
    const children = Array.from(this.element.children);
    // Capture initial positions of all toast elements
    const initialPositions = children.map(child => child.getBoundingClientRect());

    // Wait for the browser to reflow with new positions
    requestAnimationFrame(() => {
      children.forEach((child, i) => {
        const newPosition = child.getBoundingClientRect();
        const deltaY = initialPositions[i].top - newPosition.top;

        if (deltaY !== 0) {
          // Temporarily remove transition to apply the transform
          child.style.transition = 'none';
          child.style.transform = `translateY(${deltaY}px)`;
          // Force a reflow to register the transform
          child.getBoundingClientRect();
          // Animate the element back to its natural position
          child.style.transition = 'transform 0.5s ease';
          child.style.transform = '';
        }
      });
    });
  }
}
